export interface UpgradeAvailabilityDTO {
    room_available: boolean,
    eci_available: boolean,
    lco_available: boolean,
    addon_available: boolean,
}

export function countTrue(upg: UpgradeAvailabilityDTO): number {
  return (Object.values(upg) as boolean[]).filter(Boolean).length;
}